module.exports = __webpack_public_path__ + "static/img/home_8.4c6e95c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home_8.png
// module id = jYAj
// module chunks = 1